import { render } from "./Quest.vue?vue&type=template&id=571cf584"
import script from "./Quest.vue?vue&type=script&lang=js"
export * from "./Quest.vue?vue&type=script&lang=js"

import "./Quest.vue?vue&type=style&index=0&id=571cf584&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__